var canvas, canvas2, text, newText, zoom, cWidth = 2000, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4, placeholderimg5, placeholderimg6,
    placeholderimg7, placeholderimg8, placeholderimg9,
    placeholderimg10, placeholderimg11, placeholderimg12,
    img, leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 326, sizeB1H = 326,
    sizeB2W = 326, sizeB2H = 326;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');





$(document).ready(function () {
  let currentImage = null;

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }

    fabric.Image.fromURL(
      url,
      function (img) {
        img.set({
          left: halfWidth,
          top: halfHeight,
          selectable: false
        });

        img.scale(1);
        canvas2.add(img);
        canvas2.sendToBack(img);
        currentImage = img;

        canvas2.renderAll();
      },
      { crossOrigin: 'anonymous' }
    );
  }

  function setActiveBackground($btn) {
    // UI
    $('#background_design a').removeClass('active');
    $btn.addClass('active');

    // Load image
    const url = $btn.find('img').attr('data-src');
    if (url) loadImage(url);

    // Cart value
    backgroundDesign = $btn.data('title');
  }

  // =====================
  // DEFAULT LOAD
  // =====================
  const $defaultBtn = $('#icon1');
  setActiveBackground($defaultBtn);

  // =====================
  // CLICK HANDLER
  // =====================
  $('#background_design').on('click', 'a', function (e) {
    e.preventDefault();
    setActiveBackground($(this));
  });
});





// let digitImg = document.querySelector("#clock_digits");
// let clockDigitImage = new fabric.Image(digitImg, {
//   left: 465,   
//   top: 470,
//   scaleX: 1.05,
//   scaleY: 1.05,
//   selectable: false
// });

let needlesImg = document.querySelector("#clock_needles");
let clockNeedlesImage = new fabric.Image(needlesImg, {
  left: 0,   
  top: 0,
  scaleX: 1.95,
  scaleY: 1.95,
  selectable: false
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

// window['canvas2'].add(clockDigitImage);
window['canvas2'].add(clockNeedlesImage);
clockNeedlesImage.bringToFront();
addModify(window['canvas2']);



var currentDesign = 'circle';

var imagePositions = {
  image_upload_1:      { left: 1377, top: 352 },
  image_upload_2:    { left: 1649, top: 629 },
  image_upload_3:     { left: 1749, top: 1000 },

  image_upload_4:   { left: 1645, top: 1378 },
  image_upload_5: { left: 1369, top: 1645 },
  image_upload_6:  { left: 1000, top: 1750 },

  image_upload_7:   { left: 625, top: 1645 },
  image_upload_8: { left: 346, top: 1378 },
  image_upload_9:  { left: 253, top: 1000 },

  image_upload_10:     { left: 346, top: 631 },
  image_upload_11:   { left: 625, top: 352 },
  image_upload_12:    { left: 1000, top: 250 }
};

window.imageSlots = {};



var svgPaths = {
  circle: "M370 125c0 66.3-53.7 120-120 120s-120-53.7-120-120S183.7 5 250 5s120 53.7 120 120Z",
  flower: "M481.57,250c0,23.205-35.791,40.469-42.59,61.407c-7.046,21.701,11.517,56.659-1.63,74.724 c-13.276,18.242-52.348,11.324-70.593,24.603c-18.063,13.146-23.482,52.513-45.184,59.56c-20.938,6.799-48.368-21.644-71.574-21.644	c-23.205,0-50.636,28.442-71.574,21.644c-21.702-7.047-27.121-46.414-45.185-59.561c-18.244-13.277-57.315-6.359-70.593-24.602	c-13.146-18.064,5.417-53.022-1.63-74.724C54.22,290.469,18.43,273.205,18.43,250c0-23.205,35.791-40.469,42.589-61.407	c7.046-21.702-11.516-56.66,1.63-74.723c13.278-18.244,52.349-11.326,70.593-24.603c18.064-13.146,23.483-52.514,45.184-59.56	c20.939-6.798,48.369,21.644,71.575,21.644c23.206,0,50.636-28.442,71.574-21.644c21.701,7.046,27.121,46.414,45.184,59.56	c18.245,13.277,57.316,6.358,70.593,24.603c13.146,18.063-5.416,53.021,1.63,74.723C445.779,209.531,481.57,226.794,481.57,250z",
  trianglecircle: "M480.104 250 L404.709 280.815 L462.629 338.088 L381.169 337.601 L412.707 412.708 L337.601 381.17 L338.088 462.63 L280.815 404.708 L250 480.103 L219.185 404.708 L161.913 462.63 L162.398 381.169 L87.292 412.707 L118.831 337.601 L37.371 338.088 L95.291 280.815 L19.897 250 L95.291 219.185 L37.371 161.912 L118.832 162.398 L87.293 87.292 L162.399 118.831 L161.913 37.371 L219.185 95.291 L250 19.897 L280.815 95.291 L338.088 37.371 L337.602 118.831 L412.708 87.293 L381.17 162.399 L462.63 161.913 L404.709 219.185 Z"
};

var visibleShape = null;
var clipWidth = sizeB2W;


function createSvgPath(designName, left, top){

  var shape = new fabric.Path(svgPaths[designName], {
    left: left,
    top: top,
    originX: 'center',
    originY: 'center',
    absolutePositioned: true,
    selectable: false,
    evented: false
  });

  shape.scaleToWidth(clipWidth);

  return shape;
}



function createAllPlaceholders() {

  Object.keys(imagePositions).forEach(function(slotId){

    var pos = imagePositions[slotId];

    var shape = new fabric.Path(svgPaths[currentDesign], {
      left: pos.left,
      top: pos.top,
      originX: 'center',
      originY: 'center',
      fill: '#fff',
      // stroke: '#000',
      // strokeWidth: 2,
      absolutePositioned: true,
      selectable: false,
      evented: false
    });

    shape.scaleToWidth(clipWidth);

    canvas2.add(shape);

    // Store placeholder reference
    imageSlots[slotId] = {
      placeholder: shape,
      img: null,
      left: pos.left,
      top: pos.top
    };

  });

  canvas2.renderAll();
}





Object.keys(imagePositions).forEach(function(inputId){

  document.getElementById(inputId).addEventListener('change', function(e){

      window.activeSlotId = inputId;

      available_height = sizeB2H;
      sizeCrop = 1;

      reCroper = jQuery(this)
        .closest('.fileInputBlock')
        .find('.btnReCrop')
        .attr('data-height', available_height);

      readURL2(e.target);

  });

});


createAllPlaceholders();

clockNeedlesImage.bringToFront();


window['text1Page'] = new fabric.Text('check', {
  left: 995,
  top: 1350,
  fontSize: 235,
  fontFamily: 'Happy Birthday',
  // fontWeight: 'bolder',

  // 🔥 CRITICAL FIXES
  fill: '#fff',
  objectCaching: false,
  padding: 15,
  paintFirst: 'fill',

  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['text1Page'].initDimensions();


var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Malaika') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 235;
  textObj.set({ fontSize });

  while (textObj.getScaledWidth() > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  // 🔥 force recalculation (fixes cut)
  textObj.setCoords();
  window['canvas2'].requestRenderAll();
}


document.getElementById('text_1').addEventListener('input', function (e) {
  window['text1Page'].set('text', e.target.value || ' ');
  fitTextToWidth(window['text1Page'], 860);
  window['text1Page'].initDimensions();
  window['canvas2'].renderAll();
});




var maxWidth2 = 850;
var maxHeight2 = 450;

window['text2Page'] = new fabric.Text('Check', {
  left: 995,
  top: 700,
  fontSize: 200,
  // fontWeight: 'bolder',
  fontFamily: 'Happy Birthday',
  textAlign: 'center',

  // 🔥 CRITICAL FIXES
  fill: '#fff',
  objectCaching: false,
  padding: 12,
  paintFirst: 'fill',

  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['text2Page'].initDimensions();

var fontName2 = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName2 + "'").trigger('change');

window['canvas2'].add(window['text2Page']);


var minFontSize2 = 15;
var maxFontSize2 = 200;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Happy\nBirthday') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize2;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize2
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  window['text2Page'].set('text', e.target.value || ' ');
  fitTextToBox2(window['text2Page'], maxWidth2, maxHeight2);
  window['text2Page'].initDimensions();
  window['canvas2'].renderAll();
});


function fitTextToBox2(textObj, maxWidth2, maxHeight2) {
  let fontSize = maxFontSize2;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth2 || textObj.height > maxHeight2;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize2) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#000',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){

  if (!input.files || !input.files[0]) return;

  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');

  if (cropper && typeof cropper.destroy === "function") {
    cropper.destroy();
  }

  var reader = new FileReader();

  reader.onload = function (e) {

    jQuery('#blah').attr('src', e.target.result);
    reCroper.attr('data-img', e.target.result);

    document.getElementById('blah').onload = function(){
      initCropper();
    };

  };

  reader.readAsDataURL(input.files[0]);

  clockNeedlesImage.bringToFront();
}


function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  clockNeedlesImage.bringToFront();
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){

  var slotId = window.activeSlotId;
  var slot = imageSlots[slotId];

  if(!slot) return;

  // Remove old image if exists
  if(slot.img){
    canvas2.remove(slot.img);
  }

  fabric.Image.fromURL(imgurl, function(newImg){

    newImg.set({
      left: slot.left,
      top: slot.top,
      originX: 'center',
      originY: 'center',
      selectable: true
    });

    newImg.scaleToWidth(clipWidth);

    var clipShape = new fabric.Path(svgPaths[currentDesign], {
      left: slot.left,
      top: slot.top,
      originX: 'center',
      originY: 'center',
      absolutePositioned: true
    });

    clipShape.scaleToWidth(clipWidth);

    newImg.clipPath = clipShape;

    canvas2.add(newImg);

    slot.img = newImg;

    // ✅ IMPORTANT FIX
    newImg.bringToFront();
    clockNeedlesImage.bringToFront();

    canvas2.renderAll();
  });
}





jQuery('#image_design .actionBtn').on('click', function(){

  jQuery('#image_design .actionBtn').removeClass('active');
  jQuery(this).addClass('active');

  currentDesign = jQuery(this).data('title');

  Object.keys(imageSlots).forEach(function(slotId){

    var slot = imageSlots[slotId];

    // Remove old placeholder
    canvas2.remove(slot.placeholder);

    // Create new placeholder
    var newShape = new fabric.Path(svgPaths[currentDesign], {
      left: slot.left,
      top: slot.top,
      originX: 'center',
      originY: 'center',
      fill: '#fff',
      absolutePositioned: true,
      selectable: false,
      evented: false
    });

    newShape.scaleToWidth(clipWidth);

    canvas2.add(newShape);
    slot.placeholder = newShape;

    // If image exists update clipPath
    if(slot.img){

      var newClip = new fabric.Path(svgPaths[currentDesign], {
        left: slot.left,
        top: slot.top,
        originX: 'center',
        originY: 'center',
        absolutePositioned: true
      });

      newClip.scaleToWidth(clipWidth);

      slot.img.clipPath = newClip;

      // ✅ VERY IMPORTANT
      slot.img.bringToFront();
    }

  });

  // Always keep needles on top
  clockNeedlesImage.bringToFront();

  canvas2.renderAll();
});







function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){

  window.activeSlotId = jQuery(this)
  .closest('.fileInputBlock')
  .find('input[type="file"]')
  .attr('id');


  loader.removeClass('hidden');

  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');

  available_height = sizeB2H;

  jQuery('#tadaWidget').addClass('hidden');

  if (cropper && typeof cropper.destroy === "function") {
    cropper.destroy();
  }

  jQuery('#blah').attr('src', imgurl);

  document.getElementById('blah').onload = function(){
    initCropper();
    loader.addClass('hidden');
    jQuery('.popupImg').show();
  };

});


jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 860);
  fitTextToBox2(window['text2Page'], maxWidth2, maxHeight2);
});

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Malaika');
  window['text2Page'].set('text','Happy\nBirthday');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=lamaPao; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

/* fetch Call */
var size,thumbnail;
var loadedObject,currentDesign,backgroundDesign,enterText,Font1,enterEvent,Font2,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(clockNeedlesImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    currentDesign = currentDesign;
    backgroundDesign = backgroundDesign;
    enterText = jQuery('.enter_text input').val();
    Font1 = jQuery('.Font1 option:selected').val();
    enterEvent = jQuery('.enter_event textarea').val();
    Font2 = jQuery('.Font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#backgroundDesign').val(backgroundDesign);
      jQuery('#currentDesign').val(currentDesign);
      jQuery('#enterText').val(enterText);
      jQuery('#chooseFont1').val(Font1);
      jQuery('#enterEvent').val(enterEvent);
      jQuery('#chooseFont2').val(Font2);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(clockNeedlesImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}